export default {
    indexLockRules:   { method: 'get',    url: 'governance/lock-rules' },
    showLockRule:     { method: 'get',    url: 'governance/lock-rules/{id}' },
    historyLockRule:  { method: 'get',    url: 'governance/lock-rules/{id}/history' },
    createLockRule:   { method: 'post',   url: 'governance/lock-rules' },
    updateLockRule:   { method: 'put',    url: 'governance/lock-rules/{id}' },
    deleteLockRule:   { method: 'delete', url: 'governance/lock-rules/{id}' },
}
